var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknownquestion2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 334.1 394.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-4 {\n        fill: none;\n      }\n\n      .cls-1, .cls-6 {\n        stroke: #757575;\n      }\n\n      .cls-2 {\n        fill: #e9e8e8;\n        stroke: #e9e8e8;\n      }\n\n      .cls-3 {\n        fill: #4c4c4c;\n      }\n\n      .cls-3, .cls-4 {\n        stroke: #4b4c4c;\n      }\n\n      .cls-5 {\n        fill: #bababb;\n        stroke: #bababb;\n      }\n\n      .cls-6 {\n        fill: #757576;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M301.6,280.7c-9.5-20-24.4-44.8-29.5-48.5s-18.3-8.9-18.3-8.9c0,0,18-12.9,20.2-19.3,4.3-12.5-8-35-8.9-40.3s-39.4-89.7-41-94.4-30.4-44.9-34.9-47.1-61.5-12.5-61.5-12.5c0,0-28.5,12.5-33.8,15.1-4.9,2.4-6.7,9-10.5,11.7-4,2.9-22.5,29.1-24.1,33.8s2.7,34.6,2.3,48.5c-.4,13.6.4,30.6-.4,35.9s-6.9,36.7-2.6,49.2c2.2,6.4,20.2,19.3,20.2,19.3,0,0-13.2,5.2-18.3,8.9-5.2,3.7-20,28.4-29.5,48.5s-23.8,52-29.5,58.7l163.8,13.2,1-44.5,1,44.5,163.8-13.2c-5.8-6.7-20-38.6-29.5-58.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M195.4,68.9c-9.7-9.5-68.3-32.2-74.8-30.4s-24.5,40.3-30.6,53.3c-4.2,8.9-5.2,40.4-5.2,40.4l1.7,33.4,14.7,19.3s35.5,58.9,40.9,65.6,20.7,46.5,20.7,46.5h7s15.2-39.8,20.7-46.5,40-70.4,40-70.4l13.8-22-9.4-30.7-20.7-41.5s-11.7-10.2-18.7-17h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.3,350.9s20.1-44.8,24-55.7c4.2-11.8,3.6-24,3.6-24,0,0,5.9,18.8,5.9,31.6v57.8l-33.5-9.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.2,247.3s29.1,45.3,29.1,56.7,11.4,64.4,11.4,64.4l23.6-13.5-1.6-35.7-46-50.7-16.6-21.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M199.4,283l-5.7,69.6s14.4-50,18-56.6,23.2-49.6,26.9-48.7,26.6,13.7,26.9,17.4,38.9,79.6,38.9,93.7l28.2-12.8-37.9-78.1s-20.9-35.8-23.8-36-14.2-6-14.2-6c0,0-27.4,20.8-31.8,27.9-4.4,7.1-25.6,29.5-25.6,29.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M235.2,348.5c.4-13.6,7-84.9,7-84.9,0,0,11.8,11.2,13.3,24.3,1.1,9.6,10,64.8,10,64.8l-30.2-4.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.2,106.4s6.7,7.7,8.4,12.2,3.8,17.3,9.8,23.6,49.8,36,57.8,33.8,20.6-46.7,21.9-53.7-25.6-61.2-25.6-61.2l-30.4-5.2s-3.9,5.7-8.2,6.6-13.9,2.3-13.9,2.3c0,0-19.1,16.7-19.8,24.6s.2,17,.2,17h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M94.5,86.7s12.5-19.1,24.3-24c-2.8.4-6-1.4-9.2-2.6l-15.1,26.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M169.3,58s-21.6-5.6-33.7-1.4c2.3-1.6,3-5.3,4.6-8.3l29.1,9.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M145.1,53.8s16.1,3.1,21.3,11c5.1,8,6.7,23.7,6.9,25.8s0,.3-.2.3l-3.2,1.2c-.2,0-.3.3-.1.5,1.8,2,10.9,12.4,12.6,20.6s1.9,35.1,1,46.9c0,0,.5.5.6.1,2.8-9.9,10.9-39.1,10.3-44.8s-3.5-21.2-8.1-29c-4.2-7.1-2.6-13.7-2.3-14.8s0-.2,0-.3c-1.5-1.5-15.9-15.3-20.4-15.6-4.8-.4-18.3-1.8-18.3-1.8h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M156.8,136.2s6.6-8.8,5.8-10.6-12.2-14.8-13.8-25.3c-1.5-10.5,1.6-13.6,2.6-14.3s6.7-3.6,6.7-3.6c0,0-6.3,13.6-5.1,18.1s12.3,20.9,16.9,25.7l-10.6,9.1-2.6,1h.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.8,61.4c11.3-4.3,11.7-14,11.7-14,0,0,12.3,1.4,22.9,6.2,14.4,6.5,22.8,18.4,22.8,18.4,0,0-1.5,6.3,1.9,15.3,3.5,9,11.2,16.4,7.1,35.8-4.1,19.4-11.4,49.9-21.8,54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.4,137.7s.6-1.8,2.9-3.6,4.7-3.6,4.7-3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.6,143.3s-11.4,3.7-15.4,5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.6,154.7s-1.3-.5-3.6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.3,83.5c-10.2,1.9-16.8,4.8-18.6,6.5-4.7,4.4-6,10.1-6,10.1,0,0,9.3-1.2,14.7-4.8s9.9-11.8,9.9-11.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.4,100.9c-1.9-2.1.7-6.9-1.9-11.1-1.6-2.5-6.3-2.7-6.3-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179,84.2s1.9-3.2,2-6c0-5.3-6.1-3-4.3-9.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M190,102.2c3.2,4-3.7,11.4-10.6,2.7-4.9-6.1,1.6-12.1-6.1-13.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.3,61.2c-11.3,4.4-18.1-2.5-18.1-2.5,0,0-8.2,9.3-12.9,19.9-6.3,14.5-4.7,28.9-4.7,28.9,0,0,5.3,3.6,8.8,12.7,3.5,9,2.7,19.7,18.7,31.4s41.9,29.5,52.3,25.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.4,137.7s-1.6-.9-4.6-.8-5.9.5-5.9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.8,154.7s10.9-4.9,15-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.2,157.2s.6-1.3,2.9-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.8,112.1c8.9-5.4,15.7-7.7,18.2-7.6,6.4,0,11.2,3.5,11.2,3.5,0,0-7.7,5.3-14.2,6.3s-15.2-2.2-15.2-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.7,128.4c0-2.8-5.2-4.7-6-9.5-.5-2.9,2.8-6.2,2.8-6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.5,112.4s-3.6-1.1-5.5-3.1c-3.6-3.9,2.5-6.4-3-9.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.3,133.2c.3,5.1,10.3,6,9.7-5.1-.5-7.8-9.3-7.9-4.3-13.8"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M166.3,309.1l13.5-33.2s-3.4-18.7-4.1-23.2c-.8-4.5-6.7-9.8-6.7-9.8,0-.7,1.5-1.1,1.5-1.8,1-4,2.3-6.1,3.9-8.6,3.8-2.8,4.7-4.1,4.7-4.1,0,0-1.6-3.7-4.4-5.8,0,0-1.6,2.9-4.5,3.6h-4.1c0,.1-4.1,0-4.1,0-2.9-.8-4.5-3.6-4.5-3.6-2.8,2.1-4.4,5.8-4.4,5.8,0,0,.9,1.3,4.7,4.1,1.6,2.5,2.9,4.6,3.9,8.6,0,.6,1.6,1.1,1.5,1.8,0,0-5.9,5.3-6.7,9.8-.8,4.5-4.1,23.2-4.1,23.2l13.5,33.2v.5-.2c.1,0,.2.2.2.2v-.5h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M166.3,245.9s-3,6.1-2.2,7.4,2.2,1.8,2.2,1.8c0,0,1.5-.5,2.2-1.8s-2.2-7.4-2.2-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.7,244s5.1-1.9,8.6-1.9,8.8,1.9,8.8,1.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.1,210.5s-5.6-1.1-8.2-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M166.3,245.9s3,6.1,2.2,7.4-2.2,1.8-2.2,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257.6,223.3s6.1,2.4,12.9,6.4c19.8,11.7,52.2,98,60.6,108.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.3,217.8s14.6,0,25.2-20.8c0,0,13.2,8.6,14.5,9.5,0,0-8.6,31.7-15.6,37.1,0,0-14.5-25.6-24.1-25.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.8,213.4s23.3-3.9,25.9-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M166.3,245.9s-3,6.1-2.2,7.4,2.2,1.8,2.2,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.3,319.3s-16.9-48.1-20.6-58.1-56.3-89.9-59-92-5.3-30.1-4.2-36.3c2.4-13,3-38.3,4.7-41.1,6.8-10.8,23.8-49.2,33.4-53.3,9.3-4,61,16.3,69.8,24.8,1,1,15.6,10.7,23.8,22.6,9.7,14.2,21.1,34.9,25.2,46.4,2.1,6,8.1,27.7,5.4,29.8s-54.1,89.4-57.8,99.1c-3.8,10-20.6,58.1-20.6,58.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.3,352.6v-31.5s-31-35.4-48.6-57.4-57.7-50.5-61.2-58.7,4.7-50.2,4.7-50.2c0,0-4.3-75.2-1.9-84.4s28.2-44.5,31.8-46.7,35-16.1,39.1-15.5c6.1.9,56.2,8.8,60.6,13.5s35.7,42.6,38.1,51.7,28,57.8,35.2,82.1,15.4,41.3,12,49.5-43.6,36.7-61.2,58.7c-17.6,22-48.6,57.4-48.6,57.4v31.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75,223.3s-6.1,2.4-12.9,6.4c-19.8,11.7-52.2,98-60.6,108.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.3,217.8s-14.6,0-25.2-20.8c0,0-13.2,8.6-14.5,9.5,0,0,8.7,31.7,15.6,37.1,0,0,14.5-25.6,24.1-25.8h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownquestion2);
export default __webpack_public_path__ + "static/media/unknown question2.d9ffcbfb2ec55269c01e70ce226737a3.svg";
export { ForwardRef as ReactComponent };